export default __webpack_public_path__ + "ui/assets/img/o-payment-20.svg";